import { actionTypes as actionTypesEdit } from 'src/activities/status/statusAction';
import { actionTypes } from './giphyAction';

const initialState = {
  urlGif: null,
  isClick: false,
  idGif: -998,
  isSmall: false,
  urlGifComment: null
};
export function giphyReducer(state = initialState, action: any) {
  switch (action.type) {
    case actionTypes.CLICK_GIPHY: {
      return {
        ...state
      };
    }
    case actionTypes.SAVE_GIPHY: {
      return {
        ...state,
        urlGif: [{ url: action.urlGif }],
        isClick: true,
        idGif: action.id
      };
    }
    case actionTypes.CLICK_GIPHY_CLOSE: {
      return {
        ...state,
        isClick: false,
        urlGif: '',
        idGif: null,
        urlGifComment: null
      };
    }
    case actionTypes.IS_SET_POPUP_NOT_PARENT: {
      return {
        ...state,
        isSmall: true,
        urlGif: false
      };
    }
    case actionTypes.SAVE_GIFPHY_COMMENT: {
      return {
        ...state,
        urlGifComment: action.urlGif,
        isClick: true,
        idGif: action.id
      };
    }
    case actionTypesEdit.GET_STATUS_BY_ID_SUCCESS: {
      return {
        ...state,
        urlGif: action.payload.giphy && [{ url: action.payload.giphy }]
      };
    }
    case actionTypesEdit.CLOSE_MODAL: {
      return { ...state, urlGif: null };
    }
    case actionTypes.IMPORT_EDIT_GIFT_COMMENT: {
      return {
        ...state,
        urlGifComment: action.urlGif,
        idGif: action.id
      };
    }
    default:
      return state;
  }
}
